module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_3.88f05ad5.png";